module.exports = __webpack_public_path__ + "img/following-step01.c5bb0dbe.svg";